/**
 * Adivinha o primeiro nome a partir do nome guardado no contacto.
 *
 * Os contactos vêm de listas de prospecção e estão guardados como
 * "NUTRI LETICIA LOUZADA SERRA ES" ou "Fisio Vital - Taquari - RS", por isso
 * o nome cru não serve para tratar a pessoa. Isto é só um palpite: quem envia
 * vê-o num campo editável e corrige o que estiver errado.
 */
const PROFISSOES = [
  'nutri', 'nutricionista', 'fisio', 'fisioterapeuta', 'fono',
  'fonoaudiologa', 'fonoaudiologo', 'psico', 'psicologa', 'psicologo',
  'to', 'terapeuta', 'dr', 'dra', 'enf', 'enfermeira', 'enfermeiro',
];

const maiusculaInicial = palavra =>
  palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

export const adivinharPrimeiroNome = (nome = '') => {
  const antesDoTraco = nome.split(/\s[-–]\s/)[0];

  const palavras = antesDoTraco
    .replace(/[^\p{L}\s]/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);

  const candidata = palavras.find(
    p => p.length >= 3 && !PROFISSOES.includes(p.toLowerCase())
  );

  return candidata ? maiusculaInicial(candidata) : '';
};

export default adivinharPrimeiroNome;
